import { FunctionComponent, ReactElement, CSSProperties } from "react";
import { Tooltip, HStack, Icon } from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import Style from "./index.module.css";

interface IBoxTitle {
  children?: ReactElement;
  title: string;
  fontSize?: "x-small" | "small" | "medium" | "large" | string;
  textColor?: string;
  marginBottom?: string;
  paddingBottom?: string;
  backgroundColor?: string;
  tooltipText?: string;
  padding?: string;
  borderRadius?: string;
  border?: string;
  titlePadding?: string;
  titleBorderRadius?: string;
  titleBorder?: string;
  width?: string;
}

export const BoxTitle: FunctionComponent<IBoxTitle> = ({
  children,
  title,
  fontSize = "small",
  textColor = "inherit",
  marginBottom,
  paddingBottom,
  backgroundColor = "#fff",
  tooltipText,
  padding,
  borderRadius,
  border,
  titlePadding,
  titleBorderRadius,
  titleBorder,
  width,
}) => {
  const getFontSize = (size: string): string => {
    switch (size) {
      case "x-small":
        return "x-small";
      case "small":
        return "small";
      case "medium":
        return "1rem";
      case "large":
        return "1.2rem";
      default:
        return size;
    }
  };

  const getTopPosition = (size: string): string => {
    const fontSizeValue = getFontSize(size);
    switch (size) {
      case "x-small":
        return "-7px";
      case "small":
        return "-8px";
      case "medium":
        return "-10px";
      case "large":
        return "-12px";
      default:
        if (fontSizeValue.includes("px")) {
          const pxValue = parseInt(fontSizeValue);
          return `${-4 - pxValue * 0.3}px`;
        } else if (fontSizeValue.includes("rem")) {
          const remValue = parseFloat(fontSizeValue);
          return `${-8 - remValue * 4}px`;
        } else if (fontSizeValue.includes("em")) {
          const emValue = parseFloat(fontSizeValue);
          return `${-8 - emValue * 4}px`;
        }
        return "-8px";
    }
  };

  const titleStyle: CSSProperties = {
    fontSize: getFontSize(fontSize),
    color: textColor,
    top: getTopPosition(fontSize),
    background: backgroundColor,
    padding: titlePadding,
    borderRadius: titleBorderRadius,
    border: titleBorder,
  };

  const boxStyle: CSSProperties = {
    marginBottom,
    padding,
    borderRadius,
    border,
    width,
  };

  const TitleContent = (
    <p className={Style?.title} style={titleStyle}>
      {tooltipText ? (
        <HStack spacing={1.5} align="center">
          <span>{title}</span>
          <Icon as={InfoOutlineIcon} color="gray.500" w={3} h={3} />
        </HStack>
      ) : (
        title
      )}
    </p>
  );

  return (
    <>
      <div className={Style?.BoxTitle} style={boxStyle}>
        {tooltipText ? (
          <Tooltip
            label={tooltipText}
            placement="top"
            hasArrow
            bg="white"
            color="black"
            fontWeight="bold"
            borderRadius="md"
            boxShadow="md"
            p={2}
          >
            {TitleContent}
          </Tooltip>
        ) : (
          TitleContent
        )}

        {children}
      </div>
    </>
  );
};
